export const validatePhone = (phone) => (phone ? phone.replace(/[-\s+]+/g, '').length > 5 : true);
